module.exports = __webpack_public_path__ + "img/8bc7a40.jpg";